import translate from './doctor-advance-filter-options.language';

class DoctorAdvanceFilterOptionsController {
	constructor() {
		this.translate = translate;
	}

	$onInit() {
		this.selectedLanguage = this.selectedLanguage || 'any';
		this.checkGroupTimeItems = [{
			label: this.translate[this.language].before,
			value: this.timeBeforeOption
		}, {
			label: this.translate[this.language].after,
			value: this.timeAfterOption
		}]
	}

	/*
     * Execute when any value option has been changed
     */
	changeOptionValues() {
		if (angular.isFunction(this.onChange))
			this.onChange({
				$event: {
					selectedLanguage: this.selectedLanguage,
					timeBeforeOption: this.timeBeforeOption,
					timeAfterOption: this.timeAfterOption,
					childrenOption: this.childrenOption
				}
			})
	}

	/*
    * Change selected language and fire onChange callback
    */
	changeLanguage({id}) {
		this.selectedLanguage = id;
		this.changeOptionValues();
	}

	/*
    * Change value of timeBeforeOption or timeAfterOption and fire onChange callback.
    */
	changeGroupTimeValue({value, index}) {
		if (index === 0)
			this.timeBeforeOption = value;
		else if (index === 1)
			this.timeAfterOption = value;
		this.changeOptionValues();
	}

	/*
    * Change value of childrenOption and fire onChange callback.
    */
	changeSeeChildren({value}) {
		this.childrenOption = value;
		this.changeOptionValues();
	}
}

export default DoctorAdvanceFilterOptionsController;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-advance-filter-options/doctor-advance-filter-options.controller.js